  //
  // TYPEAHEAD
import { typeahead } from "jquery-typeahead/dist/jquery.typeahead.min";
import { rate_calculator } from 'components/frontend/rate_calculator';

rate_calculator();